import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export const AutoGroupTypes = BaseEnum.create({
  values: [
    // 1 - Teams are skipped as they are generated automatically via events.
    { value: 2, label: 'Jurisdictional' },
    { value: 3, label: 'Attendance' },
    { value: 4, label: 'Field' },
    // 5 - Page (Posts) - skipped as they will be generated/managed automatically (event-driven).
    { value: 6, label: 'Calculated' },
    { value: 7, label: 'Custom' },
    { value: 8, label: 'Field Values' },
  ],
});

export const AttendanceParams = BaseEnum.create({
  values: [
    { value: 'late', label: 'Late' },
    { value: 'absent', label: 'Absent' },
  ],
});

export const CalculatedParams = BaseEnum.create({
  values: [
    // preenrolledStudents calculates whether the student is a Pre-enrolled
    // student based on enrolment status being 'pre-enrolled'.
    { value: 'preenrolledStudents', label: 'Pre-Enrolled Students' },

    // newStudents calculates whether the student is a newly enrolled student
    // based on the entry date of their enrolment record, and status of current.
    { value: 'newStudents', label: 'New Students' },

    // currentStudents calculates whether the student is a currently
    // enrolled student based on enrolment status being 'current'.
    { value: 'currentStudents', label: 'Current Students' },

    // enrolledStudents calculates whether the student was a currently
    // enrolled student within the specified date range.
    { value: 'enrolledStudents', label: 'Enrolled Students' },

    // recentLeavers calculates whether the student is a former student based
    // on their enrolment status and exit date.
    { value: 'recentLeavers', label: 'Recent Leavers' },

    // nz:readingRecovery calculates whether the student meets the criteria to
    // be a part of NZ Reading Recovery.
    { value: 'nz:readingRecovery', label: 'NZ Reading Recovery' },
  ],
});

export const JurisdictionalParams = BaseEnum.create({
  values: [
    { value: 'gender', label: 'Gender' },
    { value: 'ethnicity', label: 'Ethnicity' },
    { value: 'yearLevel', label: 'Year Level' },
  ],
});
